<template>
  <b-overlay :show="processing" rounded="sm" class="overlay-display">
    <template #overlay>
      <div class="text-center">
        <b-spinner type="grow" variant="info" label="Loading..."></b-spinner>
        <p id="cancel-label">{{ processingMessage }}</p>
      </div>
    </template>
    <ErrorAlert
      :show="alert.error"
      :message="alert.message"
      @hide-alert="hideError"
    />
    <SuccessAlert
      :show="alert.success"
      :message="alert.message"
      @hide-alert="hideSuccess"
    />

    <div class="container-fluid p-0">
      <div class="row">
        <div class="col-auto">
          <h3><strong>Query Delivery Cutoff Report</strong></h3>
        </div>
      </div>

      <div class="row mt-3 mb-0 form">
        <div class="col-md-12 col-xl-12 col-12">
          <div class="form-card">
            <b-form id="form">
              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Delivery date:</label>
                    <b-form-datepicker
                      :date-format-options="{
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                      }"
                      v-model="form.deliveryDateNew"
                      v-bind:disabled="isReadOnly"
                      :date-disabled-fn="dateDisabled"
                      class="mb-2"
                      required
                    ></b-form-datepicker>
                  </b-form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-button
                    type="button"
                    variant="primary"
                    class="submit-button"
                    @click="query"
                  >
                    Query
                  </b-button>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-sm">
                  <b-form-group>
                    <label class="mt-1 report-label">Delivery Cutoff Report:</label>
                    <b-table
                      v-if="cutoffResults.length > 0"
                      :items="cutoffResults"
                      :fields="cutoffFields"
                      bordered
                      striped
                      hover
                      responsive
                      small
                      class="mt-2"
                    ></b-table>
                    <p v-else-if="queried" class="text-muted mt-2">No results found.</p>
                  </b-form-group>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import dayjs from "dayjs";
import ToastMixin from "@/mixin/toast-mixin";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import weekOfYear from "dayjs/plugin/weekOfYear";
import isoWeek from "dayjs/plugin/isoWeek";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);

import ErrorAlert from "@/components/alerts/error.vue";
import SuccessAlert from "@/components/alerts/success.vue";

import FormatMixin from "@/mixin/format-mixin";

export default {
  mixins: [FormatMixin, ToastMixin],
  components: {
    ErrorAlert,
    SuccessAlert
  },
  data() {
    return {
      processing: false,
      processingMessage: "Please wait...",
      result: "",
      isReadOnly: false,
      form: {
        deliveryDate: "",
        deliveryDateNew: "",
        lang: "en-ca"
      },

      alert: {
        error: false,
        message: ""
      },

      shippingMethodsOpt: [],
      closedDays: [],
      unavailableDates: [],
      availableDates: [],
      cutoffTime: [],
      queried: false,
      cutoffResults: [],
      cutoffFields: [
        { key: "regionName", label: "Region" },
        { key: "status", label: "Open/Closed" },
        { key: "cutoffDateTime", label: "Cutoff Date and Time (Central)" },
        { key: "cutoffType", label: "Type" },
        { key: "deliveryDate", label: "Delivery Date" }
      ]
    };
  },
  methods: {
    async query() {
      if (!this.form.deliveryDateNew) {
        this.displayMessage("warning", `Please select delivery date`);
        return;
      }
      this.processing = true;
      this.queried = false;
      this.cutoffResults = [];
      this.displayMessage("Success", "Getting data...");

      try {
        await this.queryDeliveryCutoff(
          this.form.deliveryDateNew
        );
      } catch (e) {
        console.error("query error:", e);
      }

      this.processing = false;
    },

    clearForm() {
      this.form = {
        deliveryDate: "",
        deliveryDateNew: ""
      };
    },

    async queryDeliveryCutoff(deliveryDate) {
      const url = process.env.VUE_APP_API_ADMIN_API_ENDPOINT + `/cutoff/report`;
      const params = {
        date: deliveryDate
      };
      const cutoffList = await this.axios
        .post(url, params)
        .then(res => {
          console.log("query response:", res.data);
          return res.data;
        })
        .catch(err => {
          console.log("error:", err);
          this.displayMessage(
            "warning",
            `Query DeliveryRates Exception: ${err}`
          );
        });

      this.queried = true;
      this.cutoffResults = cutoffList || [];
      if (cutoffList) {
        this.displayMessage(
          "success",
          "Delivery Cutoff Report email has been sent to caitlin@calliaflowers.com"
        );
      }
    },
    dateDisabled(ymd, date) {
      const dateSelected = dayjs.tz(ymd, "America/Winnipeg");
      const currentTimeStamp = dayjs().tz("America/Winnipeg");
      const today = currentTimeStamp.startOf("day");
      if (dateSelected.isBefore(today)) {
        return true;
      }
      return false;
    },

    hideError() {
      this.alert.error = false;
    },
    hideSuccess() {
      this.alert.success = false;
    },
    checkItems() {
      if (!this.form.deliveryDateNew) {
        this.displayMessage("warning", `Delivery Date can't be empty`);
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/form.scss";
</style>
